import { jwtDecode } from 'jwt-decode';
import { useCallback, useMemo } from 'react';

import { useAuthContext } from 'contexts/AuthProvider';

import type { AuthJwt, AuthScope } from 'models/authJwt';

export const useAccessToken = () => {
  const { accessToken, setAccessToken } = useAuthContext();

  const getTokenExpirationTime = useCallback((token?: string) => {
    if (!token) {
      return 0;
    }
    const expiration = 1_000 * (jwtDecode(token).exp ?? 0);

    return expiration - Date.now();
  }, []);

  const scopes = useMemo(() => {
    if (!accessToken) {
      return [];
    }

    const decoded = jwtDecode<AuthJwt>(accessToken);

    return decoded.scopes.split(' ') as AuthScope[];
  }, [accessToken]);

  const isImpersonating = useMemo(() => {
    if (!accessToken) {
      return false;
    }

    const decoded = jwtDecode<AuthJwt>(accessToken);

    return decoded.impersonator_id !== null;
  }, [accessToken]);

  return {
    accessToken,
    setAccessToken,
    getTokenExpirationTime,
    scopes,
    isImpersonating
  };
};
